var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.58989 1.30457C8.58989 0.851861 8.2229 0.484863 7.77018 0.484863C7.31747 0.484863 6.95047 0.851861 6.95047 1.30457V8.61568L5.07096 6.73617C4.75084 6.41605 4.23183 6.41605 3.91171 6.73617C3.5916 7.05629 3.5916 7.5753 3.91171 7.89542L7.19056 11.1743C7.51068 11.4944 8.02969 11.4944 8.34981 11.1743L11.6287 7.89542C11.9488 7.5753 11.9488 7.05629 11.6287 6.73617C11.3085 6.41605 10.7895 6.41605 10.4694 6.73617L8.58989 8.61568L8.58989 1.30457Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8743 11.6876C14.8743 11.2349 14.5074 10.8679 14.0546 10.8679C13.6019 10.8679 13.2349 11.2349 13.2349 11.6876V12.5619C13.2349 13.0147 12.8679 13.3817 12.4152 13.3817L3.12515 13.3817C2.67244 13.3817 2.30544 13.0147 2.30544 12.5619L2.30544 11.6876C2.30544 11.2349 1.93844 10.8679 1.48573 10.8679C1.03301 10.8679 0.666016 11.2349 0.666016 11.6876V12.5619C0.666016 13.9201 1.76701 15.0211 3.12515 15.0211L12.4152 15.0211C13.7734 15.0211 14.8743 13.9201 14.8743 12.5619V11.6876Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportIcon);
export default __webpack_public_path__ + "static/media/importIcon.69a05636597176ca283eb8cc7d186174.svg";
export { ForwardRef as ReactComponent };